module.exports = __webpack_public_path__ + "assets/img/driver-btn-26a0a1c7.png";